import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import {TFunction} from 'i18next'
import * as Yup from 'yup'

dayjs.extend(customParseFormat)

export const initialValues = {
  homeAddress: '',
  country: '',
  postalCode: '',
  city: '',
  isSameAddressForPartner: 'no',
  partnerCompany: 'yes',
  partnerEnumber: '',
  partnerCountry: '',
  partnerCity: '',
  partnerPostalCode: '',
  partnerHomeAddress: '',
  partnerEmail: '',
  partnerLname: '',
  partnerFname: '',
  partnerDob: '',
}

export type FormValues = typeof initialValues

export const getPASchema = (t: TFunction) =>
  Yup.object({
    homeAddress: Yup.string().required(t('common_this_field_is_required')),
    country: Yup.string().required(t('common_this_field_is_required')),
    postalCode: Yup.string().required(t('common_this_field_is_required')),
    city: Yup.string().required(t('common_this_field_is_required')),
    isSameAddressForPartner: Yup.string(),
    partnerCompany: Yup.string(),
    partnerEnumber: Yup.string(),
    partnerCountry: Yup.string().when('isSameAddressForPartner', {
      is: 'no',
      then: (schema) => schema.required(t('common_this_field_is_required')),
    }),
    partnerCity: Yup.string().when('isSameAddressForPartner', {
      is: 'no',
      then: (schema) => schema.required(t('common_this_field_is_required')),
    }),
    partnerPostalCode: Yup.string().when('isSameAddressForPartner', {
      is: 'no',
      then: (schema) => schema.required(t('common_this_field_is_required')),
    }),
    partnerHomeAddress: Yup.string().when('isSameAddressForPartner', {
      is: 'no',
      then: (schema) => schema.required(t('common_this_field_is_required')),
    }),
    partnerEmail: Yup.string()
      .email(t('profile_personal_info_please_enter_valid_email'))
      .required(t('common_this_field_is_required')),
    partnerLname: Yup.string().required(t('common_this_field_is_required')),
    partnerFname: Yup.string().required(t('common_this_field_is_required')),
    partnerDob: Yup.string()
      .required(t('common_this_field_is_required'))
      .test(
        'valid-date',
        t('budget_partner_agreement_pa_form_please_provide_date_in_dd_mm_yyyy'),
        (value) => !value || dayjs(value, 'YYYY-MM-DD', true).isValid()
      ),
  })
